import { render, staticRenderFns } from "./OriginCustomer.vue?vue&type=template&id=2479f250&"
import script from "./OriginCustomer.vue?vue&type=script&lang=js&"
export * from "./OriginCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports